import { useState, useEffect } from 'react';
export default function useGetUserData() {
    const [user, setUser] = useState({
        userId: '',
        username: '',
        userCanSave: '',
        nonce: '',
    });
    useEffect(() => {
        const userId = document.getElementById('userId').value;
        const username = document.getElementById('username').value;
        const userCanSave = document.getElementById('userCanSave').value;
        const nonce = document.getElementById('wpRestNonce').value;
        setUser({ userId, username, userCanSave, nonce });
    }, []);
    return user;
}